import React, {Component, Fragment} from 'react'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'
import ReactPlayer from 'react-player'
import {Link} from 'react-router-dom'
import Button from '@material-ui/core/Button'
import {withStyles} from '@material-ui/core/styles'
 
 
 
 
 
 

const styles = theme => ({
    buttonPadding: {
        margin: '10px',
        'border-radius': '10px',
    },
})

const Bph = (Bph) => {
    const {classes} = Bph
    const { t } = useTranslation()
    const language = useSelector(state => state.language)
    const video = 'https://cdn.mannheim-urology.com/videos/SpaceOAR_Insertion.mp4'


  
 

const MyReactPlayer = () => {
  return (
    <div style={{ position: 'relative', width: '100%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/SpaceOAR_Insertion.mp4"
        width="100%"
        height="100%"
        controls={true} startTime={7.0} playing={false}
        style={{ position: 'absolute', top: 0, left: 0 }} 
      />
    </div>
  );
};

 


    switch (language) {
        case 'EN':
            return (
                <section id="about1">
                    <div className="row">
 
                            <h2>Minimally invasive surgical therapies (MIST) for benign prostatic hyperplasia (BPH) </h2>
                            <hr/>
                        <ol>
                            <p className="white">
                        <li> <Link to="/Optilume_BPH">
                            <button className={classes.buttonPadding}>Optilume BPH</button>
                        </Link></li>
                            </p>
 
                            <p className="white">
                        <li> <Link to="/Rezum">
                            <button className={classes.buttonPadding}>Rezūm Water Vapor Therapy for a non-invasive BPH therapy</button>
                        </Link></li>
                            </p>
 
 
                        </ol>
 
                    </div>
                </section>
            )

        case 'BG':
            return (
                <section id="about1">
                    <div className="row">
                            <h2>Разширен урологичен преглед</h2>
                            <hr/>
                        <ol>
                            <p className="white">
                         <li> <Link to="/Prostate">
                            <button className={classes.buttonPadding}>Prostate check-up </button>
                        </Link></li>
                            </p>
 
                            <p className="white">
                         <li> <Link to="/KidneyHealth">
                            <button className={classes.buttonPadding}>Kidney health</button>
                        </Link></li>
                            </p>
 
                            <p className="white">
                         <li> <Link to="/TesticularHealth">
                            <button className={classes.buttonPadding}>Testicular health</button>
                        </Link></li>
                            </p>
 
                            <p className="white">
                         <li> <Link to="/HealthyBladder">
                            <button className={classes.buttonPadding}>Bladder health</button>
                        </Link></li>
                            </p>
                        </ol>

 
                    </div>
                </section>
            )
        case 'RU':
            return (
                <section id="about1">
                    <div className="row">
                        <div className="nine columns main-col">
                            <h2>ProCure использует гидрогель SpaceOAR® для дополнительной защиты</h2>
                            <hr/>
                            <p className="white">
                                SpaceOAR® Hydrogel - это временный гель для инъекций, который защищает прямую кишку у мужчин, проходящих лучевую терапию по лечению рака простаты, снижая вероятность побочных эффектов. Система SpaceOAR® уменьшает травму прямой кишки, действуя как спейсер, отталкивая прямую кишку от простаты и из области высокой дозы излучения.
                                <hr/>
                                <h2>Как работает гидрогель SpaceOAR®</h2>
                                Спейсер из гидрогеля вводится во время минимально инвазивной процедуры, и после его установки пациенты обычно не чувствуют его. Гидрогель безопасен и аналогичен другим продуктам, используемым в хирургии головного мозга, кардиологии и офтальмологии. Он остается на месте в течение трех месяцев во время лучевой терапии, а затем абсорбируется и покидает тело с мочой пациента, не оставляя ничего.
                                <hr/>
                                {/*Anatomy without SpaceOAR® Hydrogel. <br/> The rectum is next to the prostate complicating prostate radiation therapy.*/}
                                <h2>Мало места - большая разница ™</h2>
                                омещенный между простатой и прямой кишкой, гидрогель SpaceOAR выталкивает прямую кишку из области высокой дозы радиации. Как и клетки рака простаты, клетки прямой кишки также повреждаются высокой дозой радиации. Вот почему во время лучевой терапии простаты прямую кишку называют органом риска (OAR).<br/>
                        <MyReactPlayer/>
                            </p>
                        </div>
                    </div>
                </section>
            )
        default:
            return (
                <section id="about1">
                    <div className="row">
                        <div className="nine columns main-col">
                            <h2>SpaceOAR® Hydrogel for added protection</h2>
                            <hr/>
                            <p className="white">
                                SpaceOAR® Hydrogel is a temporary injectable gel that protects the rectum in men undergoing radiation therapy for prostate cancer, decreasing the likelihood of side effects. The SpaceOAR® System reduces rectal injury by acting as a spacer – pushing the rectum away from the prostate and out of the high dose radiation region.
                                <hr/>
                                <h2>How does SpaceOAR® Hydrogel work</h2>
                                The hydrogel spacer is injected during a minimally invasive procedure and once in place, patients typically can’t feel it. The hydrogel is safe and similar to other products used in brain surgery, cardiology and ophthalmology. It remains in place for three months during radiation treatment and is then absorbed and leaves the body in the patient’s urine — leaving nothing behind.
                                <hr/>
                                {/*Anatomy without SpaceOAR® Hydrogel. <br/> The rectum is next to the prostate complicating prostate radiation therapy.*/}
                                <h2>A Little Space Makes a BIG Difference™</h2>
                                Placed between the prostate and rectum, SpaceOAR hydrogel pushes the rectum out of the high dose radiation region. Like prostate cancer cells, cells in the rectum are also damaged by the high dose radiation. That’s why the rectum is called the Organ At Risk (OAR) during prostate radiation therapy.<br/>
                        <MyReactPlayer/>
                            </p>
                        </div>
                    </div>
                </section>
            )
    }
}
 
export default withStyles(styles)(Bph)



// WEBPACK FOOTER //
// ./src/Components/Bph.js